import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NudgeToLoginPopoverContainer from './NudgeToLoginPopoverContainer';
import { getWithExpiry } from '../common/Header/Headers/utils';

const useStyles = makeStyles<{ top: number }>()((theme, { top }) => ({
  popup: {
    position: 'absolute',
    top,
    zIndex: 300,
    right: 'calc((100vw - 268px) / 2)',
    [theme.breakpoints.up('sm')]: {
      right: 40,
      '&::before': {
        color: '#3753D7',
        top: -24,
        right: 24,
        content: '"▲"',
        fontSize: 24,
        position: 'absolute',
        width: 24,
        height: 22,
      },
    },
  },
}));

interface IProps {
  onClose: any;
  loginEmail: any;
  loginGoogle: any;
  getStarted: any;
}

const NudgeToLoginPopover: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const less1080 = useMediaQuery('(max-width: 1080px)');
  const isBannerHidden = getWithExpiry('mobileAppsBannerHidden');
  const [topPosition, setTopPosition] = useState(78 + (isBannerHidden ? 0 : 64));
  const { classes } = useStyles({ top: topPosition });

  useEffect(() => {
    if (less1080) setTopPosition(78 + (isBannerHidden ? 0 : 64));
  }, [isBannerHidden, less1080]);

  useEffect(() => {
    const handleStorageChange = () => {
      const newTop = getWithExpiry('mobileAppsBannerHidden');
      if (newTop) {
        setTopPosition(78);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <Box id="NudgeToLoginPopover" className={classes.popup}>
      <NudgeToLoginPopoverContainer {...props} />
    </Box>
  );
};

export default NudgeToLoginPopover;
